<template>
	<div class="container pb_0">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_personal-request-send.title1') }}<br />
						{{ $t('rtr_personal-request-send.title2') }}
					</p>
					<p class="sub_text">
						{{ $t('rtr_personal-request-send.text1') }}<br />
						{{ $t('rtr_personal-request-send.text2') }}
					</p>
					<div class="button_area">
						<button class="button_bg_red mr_10" @click="toLogin">
							{{ $t('button.asset_send') }}
						</button>
						<button class="button_bg_black" @click="notYet">
							{{ $t('button.down') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<section>
			<div class="sub_content2">
				<p class="catch_text sub_content2_pa">
					{{ $t('rtr_personal-request-send.text3') }}
				</p>
				<div class="section01 section01_pa">
					<div class="d_flex justify_center">
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/send_icon_01.png"
										alt=""
										class="mb_20"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-request-send.text4') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-request-send.text5') }}<br />
									{{ $t('rtr_personal-request-send.text6') }}<br />
									{{ $t('rtr_personal-request-send.text7') }}
								</p>
							</div>
						</div>
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/send_icon_02.png"
										alt=""
										class="mb_20"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-request-send.text8') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-request-send.text9') }}<br />
									{{ $t('rtr_personal-request-send.text10') }}<br />
									{{ $t('rtr_personal-request-send.text11') }}
								</p>
							</div>
						</div>
						<div class="rectangle_w">
							<div>
								<div>
									<img
										src="@/assets/images/sub/send_icon_03.png"
										alt=""
										class="mb_20"
									/>
								</div>
								<p class="title_bold">
									{{ $t('rtr_personal-request-send.text12') }}
								</p>
								<p class="text02">
									{{ $t('rtr_personal-request-send.text13') }}<br />
									{{ $t('rtr_personal-request-send.text14') }}
									<br />
									{{ $t('rtr_personal-request-send.text15') }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/sub/send_02.png" alt="" />
					</div>
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_personal-request-send.title4') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-request-send.text16') }}<br />
								{{ $t('rtr_personal-request-send.text17') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail type_02">
							<h2 class="title">
								{{ $t('rtr_personal-request-send.title5') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-request-send.text18') }}<br />
								{{ $t('rtr_personal-request-send.text19') }}<br /><br />{{
									$t('rtr_personal-request-send.text20')
								}}
							</p>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/send_03.png" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content1 sub_content_back mb_50">
				<div class="sub_content">
					<div class="detail_area_center">
						<div>
							<h2 class="title">
								{{ $t('rtr_personal-request-send.text21') }}<br />
								{{ $t('rtr_personal-request-send.text22') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-request-send.text23') }}
								{{ $t('rtr_personal-request-send.text24') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Send',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
